export var routes = [
  {
    name: "Zona Cliente",
    permiso: "zona_cliente",
    subRutas: [
      { path: "/informacionHuerta", name: "Información Huerta" },
      { path: "/informacioncliente/user", name: "Lecturas" },
      { path: "/produccionestimada", name: "Gráfica Producción" },
    ],
  },
  {
    name: "Inversor",
    permiso: "inversor",
    subRutas: [
      { path: "/listadoinversores", name: "Listado Inversores" },
      { path: "/listadocontadores", name: "Listado Contadores" },
      { path: "/graficapotencia", name: "Gráficas Potencia" },
      { path: "/graficaenergiaperiodo", name: "Gráficas Energía Periodo" },
      {
        path: "/graficacomparativaproduccion",
        name: "Gráficas Comparativa Producción",
      },
    ],
  },

  {
    name: "Producción",
    permiso: "produccion",
    subRutas: [
      { path: "/rendimientoinstalaciones ", name: "Rendimiento Instalaciones" },
      { path: "/lecturascontador", name: "Lectura Contador" },
      { path: "/produccionperiodo", name: "Producción Periodo" },
      { path: "/graficasLectura", name: "Gráfica Lectura" },
    ],
  },
  {
    name: "Cliente",
    permiso: "cliente",
    subRutas: [
      { path: "/listadoclientes", name: "Listado Clientes" },
      { path: "/lecturascliente", name: "Lecturas" },
    ],
  },
  {
    name: "Facturación",
    permiso: "facturacion",
    subRutas: [{ path: "/facturasemitidas", name: "Emitidas" }],
  },
  {
    name: "Estación Meteorológica",
    permiso: "estacion_metereologica",
    subRutas: [{ path: "/dashboard", name: "Index" }],
  },
  {
    name: "Radas",
    permiso: "radar",
    subRutas: [{ path: "/dashboard", name: "Index" }],
  },
];

export default routes;
